export default {"LABEL":"Danger 危险色","DESC":"危险模式是以辅助色为根基, 横向扩展的配色方案.","COMPONENTS":{"__markdown":true}}